import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/build/repo/src/page-services/page-services-view.tsx");
